import client from './client';

export async function login(email, password) {
  const { data } = await client.post('/api/auth/login', { email, password });
  return data;
}

// Returns { accessToken, refreshToken, user, tenant, teamCredentials }
export async function register(tenantName, adminName, email, password, trialDays = 30, additionalUsers = []) {
  const { data } = await client.post('/api/auth/register', {
    tenantName, adminName, email, password, trialDays, additionalUsers,
  });
  return data;
}

export async function changePassword(currentPassword, newPassword) {
  const { data } = await client.post('/api/auth/change-password', { currentPassword, newPassword });
  return data;
}

export async function refreshToken(refreshToken) {
  const { data } = await client.post('/api/auth/refresh', { refreshToken });
  return data;
}

export async function getMe() {
  const { data } = await client.get('/api/auth/me');
  return data;
}
